<template>
  <div class="login">
    <vue-particles color="#dedede" :particleOpacity="0.7" :particlesNumber="80" shapeType="circle" :particleSize="4"
      linesColor="#dedede" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150" :moveSpeed="3"
      :hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push">
    </vue-particles>
    <div class="inner-login">
      <h1 class="mt-0">{{ $t('label.titleLogin') }}</h1>
      <div class="content">
        <fieldset class="field-control objects" :class="msg['username'] ? 'error' : ''">
          <div class="input-group">
            <div class="input-group-prepend">
              <label class="label require mr-2 mb-0">{{ $t("label.username") }} </label>
            </div>
            <div class="inner-input w-100">
              <input type="text" class="form-control" v-model="username" v-on:keyup.enter="signIn()" />
              <div class="error-message w-100 clear text-left">
                {{ msg['username'] ? msg['username'][0] : '' }}
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset class="field-control objects" :class="msg['password'] ? 'error' : ''">
          <div class="input-group mb-0">
            <div class="input-group-prepend">
              <label class="label require mr-2 mb-0">{{ $t('label.password') }}</label>
            </div>
            <div class="inner-input w-100">
              <input type="password" class="form-control" v-model="password" v-on:keyup.enter="signIn()" />
              <div class="error-message w-100 clear text-left">
                {{ msg['password'] ? msg['password'][0] : '' }}
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div>
        <button type="button" class="btn btn-fill bg-primary text-white mt-4 mb-0" v-on:click="signIn()">
          {{ $t('label.login') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import apiClient from '@/axios'

export default {
  data() {
    return {
      msg: [],
      username: "",
      password: ""
    }
  },

  mounted() {
    this.$store.commit("doLogout")
  },
  methods: {
    async signIn() {
      this.msg = []

      if (!this.username || !this.password) {
        alert("Vui lòng nhập tài khoản và mật khẩu")
        return
      }

      let res
      try {
        res = await apiClient.post("/api/v1/auth/login", {
          username: this.username,
          password: this.password
        })
      } catch (error) {
        if (!error.response) {
          alert("Không thể kết nối server")
          return
        }
        const status = error.response.status
        if (status === 400) {
          this.msg = error.response.data
        } else if (status === 401) {
          alert(error.response.data?.message || "Sai tài khoản hoặc mật khẩu")
        } else {
          alert("Có lỗi xảy ra")
        }
        return
      }

      let accessToken
      if (res.data.accessToken) {
        accessToken = `Bearer ${res.data.accessToken}`
      } else if (res.headers.authorization) {
        accessToken = res.headers.authorization
      } else {
        alert("Không nhận được access token")
        return
      }

      this.$store.commit("saveJwt", accessToken)

      if (res.data.refreshToken) {
        this.$store.commit("saveRefreshToken", res.data.refreshToken)
      }

      this.$store.commit("doLogin", res.data.userInfo)

      const role = this.$store.getters.role
      if (role === 1) {
        this.$router.push("/admin")
      } else if (role === 2) {
        this.$router.push("/sale")
      } else {
        this.$router.push("/")
      }
    }
  }
}

</script>

<style scoped lang="stylus">
  #particles-js{
    position absolute;
    top 0;
    left 0;
    right 0;
    bottom 0;
    z-index: 9;
  }
  .login{
    background #2A3F54;
    position relative;
    min-height 100vh;
    padding 15px;
  }
  .inner-login{
    padding 30px;
    max-width 500px;
    text-align center;
    width calc(100% - 30px);
    background #fff;
    border-radius 5px;
    left 50%;
    top 50%;
    transform translate(-50%, -50%);
    position absolute;
    z-index 10;
  }
</style>
